<!--
 * @Author: wsx
 * @Date: 2022-01-14 11:01:30
 * @LastEditTime: 2022-06-15 18:03:54
 * @LastEditors: zhangyaowen zhangyaowen_520@163.com
 * @Description:巡防管理
-->
<template>
  <el-container class="patrolMange">
    <el-card class="tree-card" :body-style="treeCard">
      <el-input
        v-model="filterText"
        placeholder="请输入关键词"
        class="input-with-select"
      >
        <template #prefix>
          <i class="iconfont icon-31sousuo"></i>
        </template>
      </el-input>
      <div class="tree-box">
        <el-tree
          ref="treeRef"
          :data="dataSource"
          node-key="id"
          highlight-current
          :props="{ label: 'name' }"
          :default-expanded-keys="[rootNodeKey]"
          @current-change="currentChange"
          :expand-on-click-node="true"
          :filter-node-method="filterNode"
        >
        </el-tree>
      </div>
    </el-card>
    <el-card class="tabs-card">
      <patrolTable
        ref="patrolTableRef"
        :region="currentNode"
        @editPatrol="editPatrol"
        @detils="detils"
        @addPatrol="addPatrol"
      ></patrolTable>
    </el-card>
    <patrolForm
      v-if="mapVisible"
      v-model:mapVisible="mapVisible"
      :dialogStatus="dialogStatus"
      :currentNode="currentNode"
      :currentRow="currentRow"
      @patrolSubmit="submit"
    ></patrolForm>
  </el-container>
</template>
<script>
import { defineComponent, nextTick, reactive, toRefs, watch, ref } from "vue";
import patrolTable from "./components/patrolTable.vue";
import patrolForm from "./components/patrolForm.vue";
import { userDetele } from "@/api/system/patrol";
import { ElMessageBox, ElMessage } from "element-plus";
import { getMenutree } from "@/api/system/region";

import _ from "lodash";
export default defineComponent({
  name: "patrolMange",
  components: {
    patrolTable,
    patrolForm,
  },
  props: {},
  setup(props) {
    const state = reactive({
      dialogStatus: "1", // 弹框状态  1:添加；2:编辑；3:只读
      rootNodeKey: "",
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },

      treeForm: {},
      filterText: "",
      currentNode: {},
      currentNodeClone: {},
      currentNodeTree: {},
      currentRow: {},
      dataSource: [],
      mapVisible: false,
    });
    const refData = toRefs(state);
    const treeRef = ref(null);
    const patrolTableRef = ref(null);
    // 组织树的筛选
    watch(
      () => state.filterText,
      (v) => {
        treeRef.value && treeRef.value.filter(v);
      }
    );
    // 获取结构树
    const queryOrganTreAsync = async (param) => {
      const res = await getMenutree(state.treeForm);
      state.dataSource = [res.data];
      if (res.data) {
        if (param !== "updata") {
          currentChange(res.data);
          nextTick(() => {
            state.rootNodeKey = state.currentNode.id;
            // treeRef.value.setCurrentKey(state.currentNode.id);
          });
        }
      }
    };
    // 当前选中节点变化时触发的事件
    const currentChange = (item, nodes) => {
      state.currentNode = item;

      state.currentNodeTree = item;
    };
    // 对组织树节点进行筛选时执行的方法
    const filterNode = (value, data, node) => {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    };
    queryOrganTreAsync();

    // 详情
    const detils = async (row) => {
      state.dialogStatus = "3";
      state.currentRow = row;
      state.mapVisible = true;
    };
    // 编辑
    const editPatrol = async (row) => {
      state.dialogStatus = "2";
      state.mapVisible = true;
      console.log(row);
      state.currentRow = row;
    };
    // 添加
    const addPatrol = async () => {
      state.dialogStatus = "1";
      state.mapVisible = true;
    };
    const submit = () => {
      // queryOrganTreAsync();
      patrolTableRef.value && patrolTableRef.value.tableRef.refresh();
    };
    return {
      ...refData,
      patrolTableRef,
      submit,
      treeRef,
      currentChange,
      filterNode,
      editPatrol,
      detils,
      addPatrol,
    };
  },
});
</script>
<style lang="scss" scoped>
.patrolMange {
  .tree-card {
    height: 100%;
    width: 300px;
    .input-with-select {
      margin-bottom: 10px;
    }
    .tree-btn {
      margin-bottom: 10px;
    }
    .tree-box {
      flex: 1;
      overflow: auto;
      position: relative;
    }
  }
  .tabs-card {
    flex: 1;
    margin-left: 10px;
    .opertation {
      display: flex;
    }
  }
}
</style>
